import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { DynamicLogo } from "../../components/Logo";
import Logo from "./../../assets/images/Login.png";
import Login from "./Login";
import React, { useEffect } from "react";

function SignIn() {
  const isAuth = JSON.parse(localStorage.getItem("auth"));

  return (
    <Box
      sx={{
        display: { xs: "flex", lg: "grid" },
        flexDirection: "column",
        gridTemplateColumns: "1fr 1fr",
        background:
          "radial-gradient(50% 50% at 50% 50%, var(--mui-palette-gray-lightGray50) 0%, var(--mui-palette-gray-lightGray50) 100%)",
        minHeight: "100vh",
      }}
    >
      <Box sx={{ display: "flex", flex: "1 1 auto", flexDirection: "column" }}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flex: "1 1 auto",
            justifyContent: "center",
            p: 3,
          }}
        >
          <Box
            sx={{
              maxWidth: "450px",
              width: "100%",
              backgroundColor: "var(--mui-palette-common-white)",
              boxShadow: "0 4px 8px var(--mui-palette-secondary-boxShadow1)",
              p: 3,
              borderRadius: "8px",
              position: "relative",
              zIndex: 9,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                mb: 2,
              }}
            >
              <DynamicLogo colorDark="light" colorLight="dark" />
            </Box>
            <Login />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          alignItems: "center",
          color: "var(--mui-palette-common-white)",
          display: { xs: "block", lg: "flex" },
          justifyContent: "center",
          p: { xs: 0, lg: 3 },
          position: { xs: "absolute", lg: "static" },
          right: { xs: 0, lg: "auto" },
          width: { xs: "100%", lg: "auto" },
          height: { xs: "100%", lg: "auto" },
        }}
      >
        <Stack spacing={3} sx={{ height: { xs: "100%", lg: "auto" } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: { xs: "100%", lg: "auto" },
            }}
          >
            <Box
              component="img"
              alt="Widgets"
              src={Logo}
              sx={{
                height: { xs: "100%", lg: "auto" },
                width: "100%",
                maxWidth: { xs: "100%", lg: "600px" },
                objectFit: { xs: "cover", lg: "none" },
              }}
            />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
export default SignIn;
